import { axiosInstance } from "../config/axios";

const endpoint = "product/";

export const Create = async (params) => {
	try {
		const res = await axiosInstance.post(endpoint, params);
		console.log("====================================");
		console.log(res);
		console.log("====================================");
		const { data } = res;
		data["success"] = true;
		return res.data;
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};

export const Update = async (id, params) => {
	try {
		const url = endpoint + id + "/";
		const res = await axiosInstance.put(url, params);
		console.log("====================================");
		console.log(res);
		console.log("====================================");
		const { data } = res;
		data["success"] = true;
		return res.data;
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};

export const CreateOscarProduct = async (params) => {
	try {
		const res = await axiosInstance.post("create-oscar-product/", params, {
			headers: { "Content-Type": "multipart/form-data" },
		});
		console.log("====================================");
		console.log(res);
		console.log("====================================");
		const { data } = res;
		// data["success"] = true;
		return data;
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};

export const UpdateOscarProduct = async (id, params) => {
	try {
		const url = "update-oscar-product/" + id + "/";
		const res = await axiosInstance.post(url, params, {
			headers: { "Content-Type": "multipart/form-data" },
		});
		console.log("====================================");
		console.log(res);
		console.log("====================================");
		const { data } = res;
		// data["success"] = true;
		return data;
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};

const handlerEnabled = true;
export const getAllProduct = async (
	row,
	page = 1,
	filters = {},
	order_by = "-created_at"
) => {
	try {
		const res = await axiosInstance.get(endpoint, {
			params: {
				page_size: row,
				page: page,
				...{ ordering: order_by },
				...filters,
			},
			handlerEnabled,
		});

		const { data } = res;
		data["success"] = true;
		return res.data;
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};

export const getOscarProducts = async (
	row,
	page = 1,
	filters = {},
	order_by = "-created_at"
) => {
	try {
		const res = await axiosInstance.get(`oscar-product/`, {
			params: {
				page_size: row,
				page: page,
				...{ ordering: order_by },
				...filters,
			},
			handlerEnabled,
		});

		const { data } = res;
		data["success"] = true;
		return res.data;
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};

export const checkProductExistAPI = async (url) => {
	try {
		const endpoint = "product/checkexist";
		const res = await axiosInstance.get(endpoint, { params: { url: url } });

		const { data } = res;
		data["success"] = true;
		return res.data;
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};

export const getProductPreview = async (url) => {
	const postData = { product_url: url };
	const api = `product-parser`;
	const res = await axiosInstance
		.post(api, postData)
		.then((res) => {
			return res;
		})
		.catch((err) => {
			return [];
		});
	//const data = await res.json()
	return res.data;
};

export const getOldProductPreview = async (url) => {
	const postData = { product_url: url };
	const api = `old-product-parser`;
	const res = await axiosInstance
		.post(api, postData)
		.then((res) => {
			return res;
		})
		.catch((err) => {
			return [];
		});
	//const data = await res.json()
	return res.data;
};

export const getColors = async () => {
	try {
		const res = await axiosInstance.get("colors");
		const { data } = res;
		data["success"] = true;
		return res.data;
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};

export const getColorsbyKeyword = async (row, page = 1, keyword ="") => {
	try {
		const res = await axiosInstance.get("search-color", {
params: {
  ...(typeof keyword === "object" ? keyword : { name: keyword }),
  page_size: row,
  page
}
		});
		const { data } = res;
		data["success"] = true;
		return res.data;
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};

export const uploadProductsExcel = async (formData) => {
	const response = await axiosInstance.post(
		"/all_products_via_excel/",
		formData,
		{
			headers: { "Content-Type": "multipart/form-data" },
		}
	);

	return response;
};

export const uploadStatus = async (taskId) => {
	const response = await axiosInstance.get("upload_status", {
		params: { task_id: taskId },
	});

	return response; // ✅ Ensure success response format
};

export const cancelTaskAPI = async (taskId) => {
	const response = await axiosInstance.get(`cancel-task/${taskId}/`);

	return response; // ✅ Ensure success response format
};
